export const cloudfrontGeoScript = `
function getUserState() {
  if (window.location.origin.includes("localhost")) {
    window['cloudFrontUserState'] =  "CA"
    window['cloudFrontUserCountry'] =  "US"
    window['cloudFrontUserZipCode'] =  "90210"
    window['cloudFrontUserCity'] =  "Beverly Hills"
    return
  }

  window['cloudFrontUserLocationPromise'] = fetch(window.location.origin + "/utils/geo/index.html")
    .then((response) => {
      for (var pair of response.headers.entries()) {
        switch(pair[0]) {
          case 'cloudfront-viewer-country':
            window['cloudFrontUserCountry'] = pair[1]
            break
          case 'cloudfront-viewer-country-region':
            window['cloudFrontUserState'] = pair[1]
            break
          case 'cloudfront-viewer-postal-code':
            window['cloudFrontUserZipCode'] = pair[1]
            break
          case 'cloudfront-viewer-city':
            window['cloudFrontUserCity'] = pair[1]
            break
        }
      }
      if (window['cloudFrontUserCountry'] === 'PR') {
        window['cloudFrontUserState'] = 'PR'
        window['cloudFrontUserCountry'] = 'US'
      }
      if (window['cloudFrontUserZipCode']) {
        dataLayer = window.dataLayer || []
        dataLayer.push({
          event: 'user_zip',
          user_zip: window['cloudFrontUserZipCode']
        });
      }
    })
    .catch(() => {})
}


getUserState();

`;

// The first if statement handles a way to have localhost see in solar-configurator in state environment.  To change, simply change the state to 'FL'
